<template>
  <div class="page-service-repair">
    <main>
      <div class="banner-contant">
        <div class="main-content">
          <div class="left">
            <h1 class="big-minder">寄修服务</h1>
          </div>
        </div>
      </div>
    </main>
    <section class="service-sendrepair">
      <div class="send-repair1">
        <a class="repair-jump" href="repairApply.html">
          <div class="jump-title">寄修申请</div>
          <img src="imgs/button-right.png" alt="" />
        </a>
      </div>
      <div class="send-repair2">
        <div class="repair-jump" @click="onQueryImei">
          <div class="jump-title">寄修查询</div>
          <img src="imgs/button-right.png" alt="" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    onQueryImei() {
      this.$login({
        title: '寄修服务单查询',
        callback () {
          window.location.href = 'repairs.html'
        }
      })
    }
  }
}
</script>
